<template>
  <layout-default
    :floatingButton="false"
  >
    <template v-slot:toolbar>
      <v-spacer/>
      <smart-sequences-filters
        :value="queryParams.q"
        @search-clear="searchClear"
        @search-on:input="searchInput"
        @search-on:run="searchRun" />
    </template>
    <div class="sequences">
      <sequence-preview-dialog 
        :show-dialog="sequencePreviewDialog" 
        :sequence="sequenceDefinition" 
        @close-dialog="closeSequencePreviewDialog"
      />
      <v-overlay :value="loading" z-index="4">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <div class="sequences-sequences__wrapper" v-if="dialogSequenceDefinitions">
        <sequence-tile 
          v-for="sequence in dialogSequenceDefinitions" 
          :key="sequence.id"
          :id="sequence.id"
          :title="sequence.title" 
          :dayCount="sequence.dayCount" 
          :exerciseCount="sequence.exerciseCount" 
          :readonly="true"
          :collectionMode="true"
          :collectionIsOwned="sequence.owned"
          @import-sequence="importSequence"
          @preview="previewSequence" />
      </div>
      <h4 v-else>nothing found</h4>
      <v-pagination 
        v-if="dialogPagination && dialogPagination.pageCount>1"
        circle
        :length="dialogPagination.pageCount"
        :value="dialogPagination.page+1"
        @input="paginationChange"
      />
    </div>
  </layout-default>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import LayoutDefault from '@/layouts/LayoutDefault.vue';
import SmartSequencesFilters from '@/components/exercises/SmartSequencesFilters.vue';
import SequenceTile from "@/components/exercises/SequenceTile.vue"
import RouterMixin from "@/mixins/router"
import SequencePreviewDialog from '@/components/dialogs/SequencePreviewDialog.vue'

export default {
  name: "SmartSequences",
  components: {
    LayoutDefault,
    SmartSequencesFilters,
    SequenceTile,
    SequencePreviewDialog
  },
  data () {
    return {
      defaultQueryParams: {
        pageSize: 50
      },
      sequencePreviewDialog: false
    }
  },
  mixins: [RouterMixin],
  computed: {
    ...mapState('exercisesStates', [
      'dialogSequenceDefinitions',
      'sequenceDefinition',
      'loading',
      'dialogPagination'
    ])
  },
  methods: {
    ...mapActions('exercisesStates', [
      'getSharedSequenceDefinitions',
      'shareSequenceDefinition',
      'getSequenceDefinition'
    ]),
    searchClear() {
      this.getDataAction({ ...this.defaultQueryParams })
    },
    searchInput ({ key, value }) {
      this.getDataAction({ ...this.defaultQueryParams, [key]: value })
    },
    searchRun(search) {
      this.getDataAction({ ...this.defaultQueryParams, title: search })
    },
    getData (data) {
      this.getSharedSequenceDefinitions(data)
    },
    importSequence(id) {
      this.shareSequenceDefinition({sequenceId: id})
    },
    previewSequence(id) {
      this.getSequenceDefinition({id: id}).then(()=>{
        this.sequencePreviewDialog = true
      })
    },
    closeSequencePreviewDialog() {
      this.sequencePreviewDialog = false
    },
    paginationChange(input) {
      this.getDataAction({ ...this.defaultQueryParams, page: input })
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.sequences {
  padding: 2*$gutter;
  height: 100%;
  display: flex;
  flex-direction: column;
  &-sequences {
    &__wrapper {
      display: flex;
      margin-left:-$gutter/2;
      margin-right:-$gutter/2;
      flex-grow: 1;
    }
  }
  .v-pagination{
    &__item, &__navigation {
      box-shadow: none;
    }
  }
}
</style>
